import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthorizationGuard } from './shared/guards/authorization.guard';

const APP_ROUTES: Routes = [

    {
        path: '',
        redirectTo: '/campaign',
        pathMatch: 'full'
    },
    // {
    //     path: '',
    //     component: HomeComponent,
    //     loadChildren: './campaign/campaign.module#CampaignModule',
    // },
    {
        path: 'settings',
        component: HomeComponent,
        loadChildren: './settings/settings.module#SettingsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'setpassword',
        component: HomeComponent,
        loadChildren: './setpassword/setpassword.module#SetPasswordModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'users',
        component: HomeComponent,
        loadChildren: './users/user.module#UserModule',
        canActivate: [AuthorizationGuard]
    },

    {
        path: 'account',
        component: HomeComponent,
        loadChildren: './account/account.module#AccountModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'campaigns',
        component: HomeComponent,
        loadChildren: './campaigns/campaigns.module#CampaignsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'campaign',
        component: HomeComponent,
        loadChildren: './campaign/campaign.module#CampaignModule',
        // canActivate: [AuthorizationGuard]
    },
    {
        path: 'order-materials',
        component: HomeComponent,
        loadChildren: './orders/materials/fundraiser-order-materials.module#FundraiserOrderMaterialsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'order-memberships',
        component: HomeComponent,
        loadChildren: './orders/memberships/fundraiser-order-memberships.module#FundraiserOrderMembershipsModule',
        canActivate: [AuthorizationGuard]
    },

    {
        path: '**',
        redirectTo: '/',
        pathMatch: 'full'
    }
];

export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts